import { render, staticRenderFns } from "./CentroNuevo.vue?vue&type=template&id=b894622e&"
import script from "./CentroNuevo.vue?vue&type=script&lang=js&"
export * from "./CentroNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports